// source: explorer/explorer.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global =
    (typeof globalThis !== 'undefined' && globalThis) ||
    (typeof window !== 'undefined' && window) ||
    (typeof global !== 'undefined' && global) ||
    (typeof self !== 'undefined' && self) ||
    (function () { return this; }).call(null) ||
    Function('return this')();

goog.exportSymbol('proto.sgn.explorer.v1.DailyTotalLiquidity', null, global);
goog.exportSymbol('proto.sgn.explorer.v1.DailyTransactionCount', null, global);
goog.exportSymbol('proto.sgn.explorer.v1.DailyTransactionVolume', null, global);
goog.exportSymbol('proto.sgn.explorer.v1.DailyUniqueUserCount', null, global);
goog.exportSymbol('proto.sgn.explorer.v1.ErrCode', null, global);
goog.exportSymbol('proto.sgn.explorer.v1.ErrMsg', null, global);
goog.exportSymbol('proto.sgn.explorer.v1.GetDailyTotalLiquidityRequest', null, global);
goog.exportSymbol('proto.sgn.explorer.v1.GetDailyTotalLiquidityResponse', null, global);
goog.exportSymbol('proto.sgn.explorer.v1.GetDailyTransactionCountRequest', null, global);
goog.exportSymbol('proto.sgn.explorer.v1.GetDailyTransactionCountResponse', null, global);
goog.exportSymbol('proto.sgn.explorer.v1.GetDailyTransactionVolumeRequest', null, global);
goog.exportSymbol('proto.sgn.explorer.v1.GetDailyTransactionVolumeResponse', null, global);
goog.exportSymbol('proto.sgn.explorer.v1.GetDailyUniqueUserRequest', null, global);
goog.exportSymbol('proto.sgn.explorer.v1.GetDailyUniqueUserResponse', null, global);
goog.exportSymbol('proto.sgn.explorer.v1.GetTotalStatsRequest', null, global);
goog.exportSymbol('proto.sgn.explorer.v1.GetTotalStatsResponse', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.sgn.explorer.v1.GetDailyUniqueUserRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.sgn.explorer.v1.GetDailyUniqueUserRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.sgn.explorer.v1.GetDailyUniqueUserRequest.displayName = 'proto.sgn.explorer.v1.GetDailyUniqueUserRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.sgn.explorer.v1.GetDailyUniqueUserResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.sgn.explorer.v1.GetDailyUniqueUserResponse.repeatedFields_, null);
};
goog.inherits(proto.sgn.explorer.v1.GetDailyUniqueUserResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.sgn.explorer.v1.GetDailyUniqueUserResponse.displayName = 'proto.sgn.explorer.v1.GetDailyUniqueUserResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.sgn.explorer.v1.DailyUniqueUserCount = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.sgn.explorer.v1.DailyUniqueUserCount, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.sgn.explorer.v1.DailyUniqueUserCount.displayName = 'proto.sgn.explorer.v1.DailyUniqueUserCount';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.sgn.explorer.v1.GetTotalStatsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.sgn.explorer.v1.GetTotalStatsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.sgn.explorer.v1.GetTotalStatsRequest.displayName = 'proto.sgn.explorer.v1.GetTotalStatsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.sgn.explorer.v1.GetTotalStatsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.sgn.explorer.v1.GetTotalStatsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.sgn.explorer.v1.GetTotalStatsResponse.displayName = 'proto.sgn.explorer.v1.GetTotalStatsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.sgn.explorer.v1.GetDailyTotalLiquidityRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.sgn.explorer.v1.GetDailyTotalLiquidityRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.sgn.explorer.v1.GetDailyTotalLiquidityRequest.displayName = 'proto.sgn.explorer.v1.GetDailyTotalLiquidityRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.sgn.explorer.v1.GetDailyTotalLiquidityResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.sgn.explorer.v1.GetDailyTotalLiquidityResponse.repeatedFields_, null);
};
goog.inherits(proto.sgn.explorer.v1.GetDailyTotalLiquidityResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.sgn.explorer.v1.GetDailyTotalLiquidityResponse.displayName = 'proto.sgn.explorer.v1.GetDailyTotalLiquidityResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.sgn.explorer.v1.DailyTotalLiquidity = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.sgn.explorer.v1.DailyTotalLiquidity, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.sgn.explorer.v1.DailyTotalLiquidity.displayName = 'proto.sgn.explorer.v1.DailyTotalLiquidity';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.sgn.explorer.v1.GetDailyTransactionCountRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.sgn.explorer.v1.GetDailyTransactionCountRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.sgn.explorer.v1.GetDailyTransactionCountRequest.displayName = 'proto.sgn.explorer.v1.GetDailyTransactionCountRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.sgn.explorer.v1.GetDailyTransactionCountResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.sgn.explorer.v1.GetDailyTransactionCountResponse.repeatedFields_, null);
};
goog.inherits(proto.sgn.explorer.v1.GetDailyTransactionCountResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.sgn.explorer.v1.GetDailyTransactionCountResponse.displayName = 'proto.sgn.explorer.v1.GetDailyTransactionCountResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.sgn.explorer.v1.DailyTransactionCount = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.sgn.explorer.v1.DailyTransactionCount, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.sgn.explorer.v1.DailyTransactionCount.displayName = 'proto.sgn.explorer.v1.DailyTransactionCount';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.sgn.explorer.v1.GetDailyTransactionVolumeRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.sgn.explorer.v1.GetDailyTransactionVolumeRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.sgn.explorer.v1.GetDailyTransactionVolumeRequest.displayName = 'proto.sgn.explorer.v1.GetDailyTransactionVolumeRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.sgn.explorer.v1.GetDailyTransactionVolumeResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.sgn.explorer.v1.GetDailyTransactionVolumeResponse.repeatedFields_, null);
};
goog.inherits(proto.sgn.explorer.v1.GetDailyTransactionVolumeResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.sgn.explorer.v1.GetDailyTransactionVolumeResponse.displayName = 'proto.sgn.explorer.v1.GetDailyTransactionVolumeResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.sgn.explorer.v1.DailyTransactionVolume = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.sgn.explorer.v1.DailyTransactionVolume, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.sgn.explorer.v1.DailyTransactionVolume.displayName = 'proto.sgn.explorer.v1.DailyTransactionVolume';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.sgn.explorer.v1.ErrMsg = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.sgn.explorer.v1.ErrMsg, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.sgn.explorer.v1.ErrMsg.displayName = 'proto.sgn.explorer.v1.ErrMsg';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.sgn.explorer.v1.GetDailyUniqueUserRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.sgn.explorer.v1.GetDailyUniqueUserRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.sgn.explorer.v1.GetDailyUniqueUserRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.sgn.explorer.v1.GetDailyUniqueUserRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
begin: jspb.Message.getFieldWithDefault(msg, 1, 0),
end: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.sgn.explorer.v1.GetDailyUniqueUserRequest}
 */
proto.sgn.explorer.v1.GetDailyUniqueUserRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.sgn.explorer.v1.GetDailyUniqueUserRequest;
  return proto.sgn.explorer.v1.GetDailyUniqueUserRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.sgn.explorer.v1.GetDailyUniqueUserRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.sgn.explorer.v1.GetDailyUniqueUserRequest}
 */
proto.sgn.explorer.v1.GetDailyUniqueUserRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setBegin(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setEnd(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.sgn.explorer.v1.GetDailyUniqueUserRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.sgn.explorer.v1.GetDailyUniqueUserRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.sgn.explorer.v1.GetDailyUniqueUserRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.sgn.explorer.v1.GetDailyUniqueUserRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBegin();
  if (f !== 0) {
    writer.writeUint64(
      1,
      f
    );
  }
  f = message.getEnd();
  if (f !== 0) {
    writer.writeUint64(
      2,
      f
    );
  }
};


/**
 * optional uint64 begin = 1;
 * @return {number}
 */
proto.sgn.explorer.v1.GetDailyUniqueUserRequest.prototype.getBegin = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.sgn.explorer.v1.GetDailyUniqueUserRequest} returns this
 */
proto.sgn.explorer.v1.GetDailyUniqueUserRequest.prototype.setBegin = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional uint64 end = 2;
 * @return {number}
 */
proto.sgn.explorer.v1.GetDailyUniqueUserRequest.prototype.getEnd = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.sgn.explorer.v1.GetDailyUniqueUserRequest} returns this
 */
proto.sgn.explorer.v1.GetDailyUniqueUserRequest.prototype.setEnd = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.sgn.explorer.v1.GetDailyUniqueUserResponse.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.sgn.explorer.v1.GetDailyUniqueUserResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.sgn.explorer.v1.GetDailyUniqueUserResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.sgn.explorer.v1.GetDailyUniqueUserResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.sgn.explorer.v1.GetDailyUniqueUserResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
err: (f = msg.getErr()) && proto.sgn.explorer.v1.ErrMsg.toObject(includeInstance, f),
dailyUniqueUserCountList: jspb.Message.toObjectList(msg.getDailyUniqueUserCountList(),
    proto.sgn.explorer.v1.DailyUniqueUserCount.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.sgn.explorer.v1.GetDailyUniqueUserResponse}
 */
proto.sgn.explorer.v1.GetDailyUniqueUserResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.sgn.explorer.v1.GetDailyUniqueUserResponse;
  return proto.sgn.explorer.v1.GetDailyUniqueUserResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.sgn.explorer.v1.GetDailyUniqueUserResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.sgn.explorer.v1.GetDailyUniqueUserResponse}
 */
proto.sgn.explorer.v1.GetDailyUniqueUserResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.sgn.explorer.v1.ErrMsg;
      reader.readMessage(value,proto.sgn.explorer.v1.ErrMsg.deserializeBinaryFromReader);
      msg.setErr(value);
      break;
    case 2:
      var value = new proto.sgn.explorer.v1.DailyUniqueUserCount;
      reader.readMessage(value,proto.sgn.explorer.v1.DailyUniqueUserCount.deserializeBinaryFromReader);
      msg.addDailyUniqueUserCount(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.sgn.explorer.v1.GetDailyUniqueUserResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.sgn.explorer.v1.GetDailyUniqueUserResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.sgn.explorer.v1.GetDailyUniqueUserResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.sgn.explorer.v1.GetDailyUniqueUserResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getErr();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.sgn.explorer.v1.ErrMsg.serializeBinaryToWriter
    );
  }
  f = message.getDailyUniqueUserCountList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.sgn.explorer.v1.DailyUniqueUserCount.serializeBinaryToWriter
    );
  }
};


/**
 * optional ErrMsg err = 1;
 * @return {?proto.sgn.explorer.v1.ErrMsg}
 */
proto.sgn.explorer.v1.GetDailyUniqueUserResponse.prototype.getErr = function() {
  return /** @type{?proto.sgn.explorer.v1.ErrMsg} */ (
    jspb.Message.getWrapperField(this, proto.sgn.explorer.v1.ErrMsg, 1));
};


/**
 * @param {?proto.sgn.explorer.v1.ErrMsg|undefined} value
 * @return {!proto.sgn.explorer.v1.GetDailyUniqueUserResponse} returns this
*/
proto.sgn.explorer.v1.GetDailyUniqueUserResponse.prototype.setErr = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.sgn.explorer.v1.GetDailyUniqueUserResponse} returns this
 */
proto.sgn.explorer.v1.GetDailyUniqueUserResponse.prototype.clearErr = function() {
  return this.setErr(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.sgn.explorer.v1.GetDailyUniqueUserResponse.prototype.hasErr = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * repeated DailyUniqueUserCount daily_unique_user_count = 2;
 * @return {!Array<!proto.sgn.explorer.v1.DailyUniqueUserCount>}
 */
proto.sgn.explorer.v1.GetDailyUniqueUserResponse.prototype.getDailyUniqueUserCountList = function() {
  return /** @type{!Array<!proto.sgn.explorer.v1.DailyUniqueUserCount>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.sgn.explorer.v1.DailyUniqueUserCount, 2));
};


/**
 * @param {!Array<!proto.sgn.explorer.v1.DailyUniqueUserCount>} value
 * @return {!proto.sgn.explorer.v1.GetDailyUniqueUserResponse} returns this
*/
proto.sgn.explorer.v1.GetDailyUniqueUserResponse.prototype.setDailyUniqueUserCountList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.sgn.explorer.v1.DailyUniqueUserCount=} opt_value
 * @param {number=} opt_index
 * @return {!proto.sgn.explorer.v1.DailyUniqueUserCount}
 */
proto.sgn.explorer.v1.GetDailyUniqueUserResponse.prototype.addDailyUniqueUserCount = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.sgn.explorer.v1.DailyUniqueUserCount, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.sgn.explorer.v1.GetDailyUniqueUserResponse} returns this
 */
proto.sgn.explorer.v1.GetDailyUniqueUserResponse.prototype.clearDailyUniqueUserCountList = function() {
  return this.setDailyUniqueUserCountList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.sgn.explorer.v1.DailyUniqueUserCount.prototype.toObject = function(opt_includeInstance) {
  return proto.sgn.explorer.v1.DailyUniqueUserCount.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.sgn.explorer.v1.DailyUniqueUserCount} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.sgn.explorer.v1.DailyUniqueUserCount.toObject = function(includeInstance, msg) {
  var f, obj = {
time: jspb.Message.getFieldWithDefault(msg, 1, 0),
userCount: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.sgn.explorer.v1.DailyUniqueUserCount}
 */
proto.sgn.explorer.v1.DailyUniqueUserCount.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.sgn.explorer.v1.DailyUniqueUserCount;
  return proto.sgn.explorer.v1.DailyUniqueUserCount.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.sgn.explorer.v1.DailyUniqueUserCount} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.sgn.explorer.v1.DailyUniqueUserCount}
 */
proto.sgn.explorer.v1.DailyUniqueUserCount.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setTime(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setUserCount(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.sgn.explorer.v1.DailyUniqueUserCount.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.sgn.explorer.v1.DailyUniqueUserCount.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.sgn.explorer.v1.DailyUniqueUserCount} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.sgn.explorer.v1.DailyUniqueUserCount.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTime();
  if (f !== 0) {
    writer.writeUint64(
      1,
      f
    );
  }
  f = message.getUserCount();
  if (f !== 0) {
    writer.writeUint64(
      2,
      f
    );
  }
};


/**
 * optional uint64 time = 1;
 * @return {number}
 */
proto.sgn.explorer.v1.DailyUniqueUserCount.prototype.getTime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.sgn.explorer.v1.DailyUniqueUserCount} returns this
 */
proto.sgn.explorer.v1.DailyUniqueUserCount.prototype.setTime = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional uint64 user_count = 2;
 * @return {number}
 */
proto.sgn.explorer.v1.DailyUniqueUserCount.prototype.getUserCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.sgn.explorer.v1.DailyUniqueUserCount} returns this
 */
proto.sgn.explorer.v1.DailyUniqueUserCount.prototype.setUserCount = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.sgn.explorer.v1.GetTotalStatsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.sgn.explorer.v1.GetTotalStatsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.sgn.explorer.v1.GetTotalStatsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.sgn.explorer.v1.GetTotalStatsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.sgn.explorer.v1.GetTotalStatsRequest}
 */
proto.sgn.explorer.v1.GetTotalStatsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.sgn.explorer.v1.GetTotalStatsRequest;
  return proto.sgn.explorer.v1.GetTotalStatsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.sgn.explorer.v1.GetTotalStatsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.sgn.explorer.v1.GetTotalStatsRequest}
 */
proto.sgn.explorer.v1.GetTotalStatsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.sgn.explorer.v1.GetTotalStatsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.sgn.explorer.v1.GetTotalStatsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.sgn.explorer.v1.GetTotalStatsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.sgn.explorer.v1.GetTotalStatsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.sgn.explorer.v1.GetTotalStatsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.sgn.explorer.v1.GetTotalStatsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.sgn.explorer.v1.GetTotalStatsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.sgn.explorer.v1.GetTotalStatsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
err: (f = msg.getErr()) && proto.sgn.explorer.v1.ErrMsg.toObject(includeInstance, f),
totalTransactionVolume: jspb.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0),
totalTransactionCount: jspb.Message.getFieldWithDefault(msg, 3, 0),
last24TotalTransactionVolume: jspb.Message.getFloatingPointFieldWithDefault(msg, 4, 0.0),
last24TotalTransactionCount: jspb.Message.getFieldWithDefault(msg, 5, 0),
totalLiquidity: jspb.Message.getFloatingPointFieldWithDefault(msg, 6, 0.0),
uniqueAddress: jspb.Message.getFieldWithDefault(msg, 7, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.sgn.explorer.v1.GetTotalStatsResponse}
 */
proto.sgn.explorer.v1.GetTotalStatsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.sgn.explorer.v1.GetTotalStatsResponse;
  return proto.sgn.explorer.v1.GetTotalStatsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.sgn.explorer.v1.GetTotalStatsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.sgn.explorer.v1.GetTotalStatsResponse}
 */
proto.sgn.explorer.v1.GetTotalStatsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.sgn.explorer.v1.ErrMsg;
      reader.readMessage(value,proto.sgn.explorer.v1.ErrMsg.deserializeBinaryFromReader);
      msg.setErr(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setTotalTransactionVolume(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setTotalTransactionCount(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setLast24TotalTransactionVolume(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setLast24TotalTransactionCount(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setTotalLiquidity(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setUniqueAddress(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.sgn.explorer.v1.GetTotalStatsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.sgn.explorer.v1.GetTotalStatsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.sgn.explorer.v1.GetTotalStatsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.sgn.explorer.v1.GetTotalStatsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getErr();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.sgn.explorer.v1.ErrMsg.serializeBinaryToWriter
    );
  }
  f = message.getTotalTransactionVolume();
  if (f !== 0.0) {
    writer.writeDouble(
      2,
      f
    );
  }
  f = message.getTotalTransactionCount();
  if (f !== 0) {
    writer.writeUint64(
      3,
      f
    );
  }
  f = message.getLast24TotalTransactionVolume();
  if (f !== 0.0) {
    writer.writeDouble(
      4,
      f
    );
  }
  f = message.getLast24TotalTransactionCount();
  if (f !== 0) {
    writer.writeUint64(
      5,
      f
    );
  }
  f = message.getTotalLiquidity();
  if (f !== 0.0) {
    writer.writeDouble(
      6,
      f
    );
  }
  f = message.getUniqueAddress();
  if (f !== 0) {
    writer.writeUint64(
      7,
      f
    );
  }
};


/**
 * optional ErrMsg err = 1;
 * @return {?proto.sgn.explorer.v1.ErrMsg}
 */
proto.sgn.explorer.v1.GetTotalStatsResponse.prototype.getErr = function() {
  return /** @type{?proto.sgn.explorer.v1.ErrMsg} */ (
    jspb.Message.getWrapperField(this, proto.sgn.explorer.v1.ErrMsg, 1));
};


/**
 * @param {?proto.sgn.explorer.v1.ErrMsg|undefined} value
 * @return {!proto.sgn.explorer.v1.GetTotalStatsResponse} returns this
*/
proto.sgn.explorer.v1.GetTotalStatsResponse.prototype.setErr = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.sgn.explorer.v1.GetTotalStatsResponse} returns this
 */
proto.sgn.explorer.v1.GetTotalStatsResponse.prototype.clearErr = function() {
  return this.setErr(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.sgn.explorer.v1.GetTotalStatsResponse.prototype.hasErr = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional double total_transaction_volume = 2;
 * @return {number}
 */
proto.sgn.explorer.v1.GetTotalStatsResponse.prototype.getTotalTransactionVolume = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.sgn.explorer.v1.GetTotalStatsResponse} returns this
 */
proto.sgn.explorer.v1.GetTotalStatsResponse.prototype.setTotalTransactionVolume = function(value) {
  return jspb.Message.setProto3FloatField(this, 2, value);
};


/**
 * optional uint64 total_transaction_count = 3;
 * @return {number}
 */
proto.sgn.explorer.v1.GetTotalStatsResponse.prototype.getTotalTransactionCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.sgn.explorer.v1.GetTotalStatsResponse} returns this
 */
proto.sgn.explorer.v1.GetTotalStatsResponse.prototype.setTotalTransactionCount = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional double last_24_total_transaction_volume = 4;
 * @return {number}
 */
proto.sgn.explorer.v1.GetTotalStatsResponse.prototype.getLast24TotalTransactionVolume = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 4, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.sgn.explorer.v1.GetTotalStatsResponse} returns this
 */
proto.sgn.explorer.v1.GetTotalStatsResponse.prototype.setLast24TotalTransactionVolume = function(value) {
  return jspb.Message.setProto3FloatField(this, 4, value);
};


/**
 * optional uint64 last_24_total_transaction_count = 5;
 * @return {number}
 */
proto.sgn.explorer.v1.GetTotalStatsResponse.prototype.getLast24TotalTransactionCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.sgn.explorer.v1.GetTotalStatsResponse} returns this
 */
proto.sgn.explorer.v1.GetTotalStatsResponse.prototype.setLast24TotalTransactionCount = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional double total_liquidity = 6;
 * @return {number}
 */
proto.sgn.explorer.v1.GetTotalStatsResponse.prototype.getTotalLiquidity = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 6, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.sgn.explorer.v1.GetTotalStatsResponse} returns this
 */
proto.sgn.explorer.v1.GetTotalStatsResponse.prototype.setTotalLiquidity = function(value) {
  return jspb.Message.setProto3FloatField(this, 6, value);
};


/**
 * optional uint64 unique_address = 7;
 * @return {number}
 */
proto.sgn.explorer.v1.GetTotalStatsResponse.prototype.getUniqueAddress = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.sgn.explorer.v1.GetTotalStatsResponse} returns this
 */
proto.sgn.explorer.v1.GetTotalStatsResponse.prototype.setUniqueAddress = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.sgn.explorer.v1.GetDailyTotalLiquidityRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.sgn.explorer.v1.GetDailyTotalLiquidityRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.sgn.explorer.v1.GetDailyTotalLiquidityRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.sgn.explorer.v1.GetDailyTotalLiquidityRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
begin: jspb.Message.getFieldWithDefault(msg, 1, 0),
end: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.sgn.explorer.v1.GetDailyTotalLiquidityRequest}
 */
proto.sgn.explorer.v1.GetDailyTotalLiquidityRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.sgn.explorer.v1.GetDailyTotalLiquidityRequest;
  return proto.sgn.explorer.v1.GetDailyTotalLiquidityRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.sgn.explorer.v1.GetDailyTotalLiquidityRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.sgn.explorer.v1.GetDailyTotalLiquidityRequest}
 */
proto.sgn.explorer.v1.GetDailyTotalLiquidityRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setBegin(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setEnd(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.sgn.explorer.v1.GetDailyTotalLiquidityRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.sgn.explorer.v1.GetDailyTotalLiquidityRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.sgn.explorer.v1.GetDailyTotalLiquidityRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.sgn.explorer.v1.GetDailyTotalLiquidityRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBegin();
  if (f !== 0) {
    writer.writeUint64(
      1,
      f
    );
  }
  f = message.getEnd();
  if (f !== 0) {
    writer.writeUint64(
      2,
      f
    );
  }
};


/**
 * optional uint64 begin = 1;
 * @return {number}
 */
proto.sgn.explorer.v1.GetDailyTotalLiquidityRequest.prototype.getBegin = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.sgn.explorer.v1.GetDailyTotalLiquidityRequest} returns this
 */
proto.sgn.explorer.v1.GetDailyTotalLiquidityRequest.prototype.setBegin = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional uint64 end = 2;
 * @return {number}
 */
proto.sgn.explorer.v1.GetDailyTotalLiquidityRequest.prototype.getEnd = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.sgn.explorer.v1.GetDailyTotalLiquidityRequest} returns this
 */
proto.sgn.explorer.v1.GetDailyTotalLiquidityRequest.prototype.setEnd = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.sgn.explorer.v1.GetDailyTotalLiquidityResponse.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.sgn.explorer.v1.GetDailyTotalLiquidityResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.sgn.explorer.v1.GetDailyTotalLiquidityResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.sgn.explorer.v1.GetDailyTotalLiquidityResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.sgn.explorer.v1.GetDailyTotalLiquidityResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
err: (f = msg.getErr()) && proto.sgn.explorer.v1.ErrMsg.toObject(includeInstance, f),
dailyLiquidityList: jspb.Message.toObjectList(msg.getDailyLiquidityList(),
    proto.sgn.explorer.v1.DailyTotalLiquidity.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.sgn.explorer.v1.GetDailyTotalLiquidityResponse}
 */
proto.sgn.explorer.v1.GetDailyTotalLiquidityResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.sgn.explorer.v1.GetDailyTotalLiquidityResponse;
  return proto.sgn.explorer.v1.GetDailyTotalLiquidityResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.sgn.explorer.v1.GetDailyTotalLiquidityResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.sgn.explorer.v1.GetDailyTotalLiquidityResponse}
 */
proto.sgn.explorer.v1.GetDailyTotalLiquidityResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.sgn.explorer.v1.ErrMsg;
      reader.readMessage(value,proto.sgn.explorer.v1.ErrMsg.deserializeBinaryFromReader);
      msg.setErr(value);
      break;
    case 2:
      var value = new proto.sgn.explorer.v1.DailyTotalLiquidity;
      reader.readMessage(value,proto.sgn.explorer.v1.DailyTotalLiquidity.deserializeBinaryFromReader);
      msg.addDailyLiquidity(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.sgn.explorer.v1.GetDailyTotalLiquidityResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.sgn.explorer.v1.GetDailyTotalLiquidityResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.sgn.explorer.v1.GetDailyTotalLiquidityResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.sgn.explorer.v1.GetDailyTotalLiquidityResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getErr();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.sgn.explorer.v1.ErrMsg.serializeBinaryToWriter
    );
  }
  f = message.getDailyLiquidityList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.sgn.explorer.v1.DailyTotalLiquidity.serializeBinaryToWriter
    );
  }
};


/**
 * optional ErrMsg err = 1;
 * @return {?proto.sgn.explorer.v1.ErrMsg}
 */
proto.sgn.explorer.v1.GetDailyTotalLiquidityResponse.prototype.getErr = function() {
  return /** @type{?proto.sgn.explorer.v1.ErrMsg} */ (
    jspb.Message.getWrapperField(this, proto.sgn.explorer.v1.ErrMsg, 1));
};


/**
 * @param {?proto.sgn.explorer.v1.ErrMsg|undefined} value
 * @return {!proto.sgn.explorer.v1.GetDailyTotalLiquidityResponse} returns this
*/
proto.sgn.explorer.v1.GetDailyTotalLiquidityResponse.prototype.setErr = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.sgn.explorer.v1.GetDailyTotalLiquidityResponse} returns this
 */
proto.sgn.explorer.v1.GetDailyTotalLiquidityResponse.prototype.clearErr = function() {
  return this.setErr(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.sgn.explorer.v1.GetDailyTotalLiquidityResponse.prototype.hasErr = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * repeated DailyTotalLiquidity daily_liquidity = 2;
 * @return {!Array<!proto.sgn.explorer.v1.DailyTotalLiquidity>}
 */
proto.sgn.explorer.v1.GetDailyTotalLiquidityResponse.prototype.getDailyLiquidityList = function() {
  return /** @type{!Array<!proto.sgn.explorer.v1.DailyTotalLiquidity>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.sgn.explorer.v1.DailyTotalLiquidity, 2));
};


/**
 * @param {!Array<!proto.sgn.explorer.v1.DailyTotalLiquidity>} value
 * @return {!proto.sgn.explorer.v1.GetDailyTotalLiquidityResponse} returns this
*/
proto.sgn.explorer.v1.GetDailyTotalLiquidityResponse.prototype.setDailyLiquidityList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.sgn.explorer.v1.DailyTotalLiquidity=} opt_value
 * @param {number=} opt_index
 * @return {!proto.sgn.explorer.v1.DailyTotalLiquidity}
 */
proto.sgn.explorer.v1.GetDailyTotalLiquidityResponse.prototype.addDailyLiquidity = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.sgn.explorer.v1.DailyTotalLiquidity, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.sgn.explorer.v1.GetDailyTotalLiquidityResponse} returns this
 */
proto.sgn.explorer.v1.GetDailyTotalLiquidityResponse.prototype.clearDailyLiquidityList = function() {
  return this.setDailyLiquidityList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.sgn.explorer.v1.DailyTotalLiquidity.prototype.toObject = function(opt_includeInstance) {
  return proto.sgn.explorer.v1.DailyTotalLiquidity.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.sgn.explorer.v1.DailyTotalLiquidity} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.sgn.explorer.v1.DailyTotalLiquidity.toObject = function(includeInstance, msg) {
  var f, obj = {
time: jspb.Message.getFieldWithDefault(msg, 1, 0),
totalLiquidity: jspb.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.sgn.explorer.v1.DailyTotalLiquidity}
 */
proto.sgn.explorer.v1.DailyTotalLiquidity.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.sgn.explorer.v1.DailyTotalLiquidity;
  return proto.sgn.explorer.v1.DailyTotalLiquidity.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.sgn.explorer.v1.DailyTotalLiquidity} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.sgn.explorer.v1.DailyTotalLiquidity}
 */
proto.sgn.explorer.v1.DailyTotalLiquidity.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setTime(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setTotalLiquidity(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.sgn.explorer.v1.DailyTotalLiquidity.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.sgn.explorer.v1.DailyTotalLiquidity.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.sgn.explorer.v1.DailyTotalLiquidity} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.sgn.explorer.v1.DailyTotalLiquidity.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTime();
  if (f !== 0) {
    writer.writeUint64(
      1,
      f
    );
  }
  f = message.getTotalLiquidity();
  if (f !== 0.0) {
    writer.writeDouble(
      2,
      f
    );
  }
};


/**
 * optional uint64 time = 1;
 * @return {number}
 */
proto.sgn.explorer.v1.DailyTotalLiquidity.prototype.getTime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.sgn.explorer.v1.DailyTotalLiquidity} returns this
 */
proto.sgn.explorer.v1.DailyTotalLiquidity.prototype.setTime = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional double total_liquidity = 2;
 * @return {number}
 */
proto.sgn.explorer.v1.DailyTotalLiquidity.prototype.getTotalLiquidity = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.sgn.explorer.v1.DailyTotalLiquidity} returns this
 */
proto.sgn.explorer.v1.DailyTotalLiquidity.prototype.setTotalLiquidity = function(value) {
  return jspb.Message.setProto3FloatField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.sgn.explorer.v1.GetDailyTransactionCountRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.sgn.explorer.v1.GetDailyTransactionCountRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.sgn.explorer.v1.GetDailyTransactionCountRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.sgn.explorer.v1.GetDailyTransactionCountRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
begin: jspb.Message.getFieldWithDefault(msg, 1, 0),
end: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.sgn.explorer.v1.GetDailyTransactionCountRequest}
 */
proto.sgn.explorer.v1.GetDailyTransactionCountRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.sgn.explorer.v1.GetDailyTransactionCountRequest;
  return proto.sgn.explorer.v1.GetDailyTransactionCountRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.sgn.explorer.v1.GetDailyTransactionCountRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.sgn.explorer.v1.GetDailyTransactionCountRequest}
 */
proto.sgn.explorer.v1.GetDailyTransactionCountRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setBegin(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setEnd(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.sgn.explorer.v1.GetDailyTransactionCountRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.sgn.explorer.v1.GetDailyTransactionCountRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.sgn.explorer.v1.GetDailyTransactionCountRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.sgn.explorer.v1.GetDailyTransactionCountRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBegin();
  if (f !== 0) {
    writer.writeUint64(
      1,
      f
    );
  }
  f = message.getEnd();
  if (f !== 0) {
    writer.writeUint64(
      2,
      f
    );
  }
};


/**
 * optional uint64 begin = 1;
 * @return {number}
 */
proto.sgn.explorer.v1.GetDailyTransactionCountRequest.prototype.getBegin = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.sgn.explorer.v1.GetDailyTransactionCountRequest} returns this
 */
proto.sgn.explorer.v1.GetDailyTransactionCountRequest.prototype.setBegin = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional uint64 end = 2;
 * @return {number}
 */
proto.sgn.explorer.v1.GetDailyTransactionCountRequest.prototype.getEnd = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.sgn.explorer.v1.GetDailyTransactionCountRequest} returns this
 */
proto.sgn.explorer.v1.GetDailyTransactionCountRequest.prototype.setEnd = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.sgn.explorer.v1.GetDailyTransactionCountResponse.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.sgn.explorer.v1.GetDailyTransactionCountResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.sgn.explorer.v1.GetDailyTransactionCountResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.sgn.explorer.v1.GetDailyTransactionCountResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.sgn.explorer.v1.GetDailyTransactionCountResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
err: (f = msg.getErr()) && proto.sgn.explorer.v1.ErrMsg.toObject(includeInstance, f),
dailyTransactionCountList: jspb.Message.toObjectList(msg.getDailyTransactionCountList(),
    proto.sgn.explorer.v1.DailyTransactionCount.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.sgn.explorer.v1.GetDailyTransactionCountResponse}
 */
proto.sgn.explorer.v1.GetDailyTransactionCountResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.sgn.explorer.v1.GetDailyTransactionCountResponse;
  return proto.sgn.explorer.v1.GetDailyTransactionCountResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.sgn.explorer.v1.GetDailyTransactionCountResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.sgn.explorer.v1.GetDailyTransactionCountResponse}
 */
proto.sgn.explorer.v1.GetDailyTransactionCountResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.sgn.explorer.v1.ErrMsg;
      reader.readMessage(value,proto.sgn.explorer.v1.ErrMsg.deserializeBinaryFromReader);
      msg.setErr(value);
      break;
    case 2:
      var value = new proto.sgn.explorer.v1.DailyTransactionCount;
      reader.readMessage(value,proto.sgn.explorer.v1.DailyTransactionCount.deserializeBinaryFromReader);
      msg.addDailyTransactionCount(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.sgn.explorer.v1.GetDailyTransactionCountResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.sgn.explorer.v1.GetDailyTransactionCountResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.sgn.explorer.v1.GetDailyTransactionCountResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.sgn.explorer.v1.GetDailyTransactionCountResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getErr();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.sgn.explorer.v1.ErrMsg.serializeBinaryToWriter
    );
  }
  f = message.getDailyTransactionCountList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.sgn.explorer.v1.DailyTransactionCount.serializeBinaryToWriter
    );
  }
};


/**
 * optional ErrMsg err = 1;
 * @return {?proto.sgn.explorer.v1.ErrMsg}
 */
proto.sgn.explorer.v1.GetDailyTransactionCountResponse.prototype.getErr = function() {
  return /** @type{?proto.sgn.explorer.v1.ErrMsg} */ (
    jspb.Message.getWrapperField(this, proto.sgn.explorer.v1.ErrMsg, 1));
};


/**
 * @param {?proto.sgn.explorer.v1.ErrMsg|undefined} value
 * @return {!proto.sgn.explorer.v1.GetDailyTransactionCountResponse} returns this
*/
proto.sgn.explorer.v1.GetDailyTransactionCountResponse.prototype.setErr = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.sgn.explorer.v1.GetDailyTransactionCountResponse} returns this
 */
proto.sgn.explorer.v1.GetDailyTransactionCountResponse.prototype.clearErr = function() {
  return this.setErr(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.sgn.explorer.v1.GetDailyTransactionCountResponse.prototype.hasErr = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * repeated DailyTransactionCount daily_transaction_count = 2;
 * @return {!Array<!proto.sgn.explorer.v1.DailyTransactionCount>}
 */
proto.sgn.explorer.v1.GetDailyTransactionCountResponse.prototype.getDailyTransactionCountList = function() {
  return /** @type{!Array<!proto.sgn.explorer.v1.DailyTransactionCount>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.sgn.explorer.v1.DailyTransactionCount, 2));
};


/**
 * @param {!Array<!proto.sgn.explorer.v1.DailyTransactionCount>} value
 * @return {!proto.sgn.explorer.v1.GetDailyTransactionCountResponse} returns this
*/
proto.sgn.explorer.v1.GetDailyTransactionCountResponse.prototype.setDailyTransactionCountList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.sgn.explorer.v1.DailyTransactionCount=} opt_value
 * @param {number=} opt_index
 * @return {!proto.sgn.explorer.v1.DailyTransactionCount}
 */
proto.sgn.explorer.v1.GetDailyTransactionCountResponse.prototype.addDailyTransactionCount = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.sgn.explorer.v1.DailyTransactionCount, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.sgn.explorer.v1.GetDailyTransactionCountResponse} returns this
 */
proto.sgn.explorer.v1.GetDailyTransactionCountResponse.prototype.clearDailyTransactionCountList = function() {
  return this.setDailyTransactionCountList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.sgn.explorer.v1.DailyTransactionCount.prototype.toObject = function(opt_includeInstance) {
  return proto.sgn.explorer.v1.DailyTransactionCount.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.sgn.explorer.v1.DailyTransactionCount} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.sgn.explorer.v1.DailyTransactionCount.toObject = function(includeInstance, msg) {
  var f, obj = {
time: jspb.Message.getFieldWithDefault(msg, 1, 0),
transactionCount: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.sgn.explorer.v1.DailyTransactionCount}
 */
proto.sgn.explorer.v1.DailyTransactionCount.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.sgn.explorer.v1.DailyTransactionCount;
  return proto.sgn.explorer.v1.DailyTransactionCount.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.sgn.explorer.v1.DailyTransactionCount} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.sgn.explorer.v1.DailyTransactionCount}
 */
proto.sgn.explorer.v1.DailyTransactionCount.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setTime(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setTransactionCount(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.sgn.explorer.v1.DailyTransactionCount.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.sgn.explorer.v1.DailyTransactionCount.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.sgn.explorer.v1.DailyTransactionCount} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.sgn.explorer.v1.DailyTransactionCount.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTime();
  if (f !== 0) {
    writer.writeUint64(
      1,
      f
    );
  }
  f = message.getTransactionCount();
  if (f !== 0) {
    writer.writeUint64(
      2,
      f
    );
  }
};


/**
 * optional uint64 time = 1;
 * @return {number}
 */
proto.sgn.explorer.v1.DailyTransactionCount.prototype.getTime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.sgn.explorer.v1.DailyTransactionCount} returns this
 */
proto.sgn.explorer.v1.DailyTransactionCount.prototype.setTime = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional uint64 transaction_count = 2;
 * @return {number}
 */
proto.sgn.explorer.v1.DailyTransactionCount.prototype.getTransactionCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.sgn.explorer.v1.DailyTransactionCount} returns this
 */
proto.sgn.explorer.v1.DailyTransactionCount.prototype.setTransactionCount = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.sgn.explorer.v1.GetDailyTransactionVolumeRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.sgn.explorer.v1.GetDailyTransactionVolumeRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.sgn.explorer.v1.GetDailyTransactionVolumeRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.sgn.explorer.v1.GetDailyTransactionVolumeRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
begin: jspb.Message.getFieldWithDefault(msg, 1, 0),
end: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.sgn.explorer.v1.GetDailyTransactionVolumeRequest}
 */
proto.sgn.explorer.v1.GetDailyTransactionVolumeRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.sgn.explorer.v1.GetDailyTransactionVolumeRequest;
  return proto.sgn.explorer.v1.GetDailyTransactionVolumeRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.sgn.explorer.v1.GetDailyTransactionVolumeRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.sgn.explorer.v1.GetDailyTransactionVolumeRequest}
 */
proto.sgn.explorer.v1.GetDailyTransactionVolumeRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setBegin(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setEnd(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.sgn.explorer.v1.GetDailyTransactionVolumeRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.sgn.explorer.v1.GetDailyTransactionVolumeRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.sgn.explorer.v1.GetDailyTransactionVolumeRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.sgn.explorer.v1.GetDailyTransactionVolumeRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBegin();
  if (f !== 0) {
    writer.writeUint64(
      1,
      f
    );
  }
  f = message.getEnd();
  if (f !== 0) {
    writer.writeUint64(
      2,
      f
    );
  }
};


/**
 * optional uint64 begin = 1;
 * @return {number}
 */
proto.sgn.explorer.v1.GetDailyTransactionVolumeRequest.prototype.getBegin = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.sgn.explorer.v1.GetDailyTransactionVolumeRequest} returns this
 */
proto.sgn.explorer.v1.GetDailyTransactionVolumeRequest.prototype.setBegin = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional uint64 end = 2;
 * @return {number}
 */
proto.sgn.explorer.v1.GetDailyTransactionVolumeRequest.prototype.getEnd = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.sgn.explorer.v1.GetDailyTransactionVolumeRequest} returns this
 */
proto.sgn.explorer.v1.GetDailyTransactionVolumeRequest.prototype.setEnd = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.sgn.explorer.v1.GetDailyTransactionVolumeResponse.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.sgn.explorer.v1.GetDailyTransactionVolumeResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.sgn.explorer.v1.GetDailyTransactionVolumeResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.sgn.explorer.v1.GetDailyTransactionVolumeResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.sgn.explorer.v1.GetDailyTransactionVolumeResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
err: (f = msg.getErr()) && proto.sgn.explorer.v1.ErrMsg.toObject(includeInstance, f),
dailyTransactionVolumeList: jspb.Message.toObjectList(msg.getDailyTransactionVolumeList(),
    proto.sgn.explorer.v1.DailyTransactionVolume.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.sgn.explorer.v1.GetDailyTransactionVolumeResponse}
 */
proto.sgn.explorer.v1.GetDailyTransactionVolumeResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.sgn.explorer.v1.GetDailyTransactionVolumeResponse;
  return proto.sgn.explorer.v1.GetDailyTransactionVolumeResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.sgn.explorer.v1.GetDailyTransactionVolumeResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.sgn.explorer.v1.GetDailyTransactionVolumeResponse}
 */
proto.sgn.explorer.v1.GetDailyTransactionVolumeResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.sgn.explorer.v1.ErrMsg;
      reader.readMessage(value,proto.sgn.explorer.v1.ErrMsg.deserializeBinaryFromReader);
      msg.setErr(value);
      break;
    case 2:
      var value = new proto.sgn.explorer.v1.DailyTransactionVolume;
      reader.readMessage(value,proto.sgn.explorer.v1.DailyTransactionVolume.deserializeBinaryFromReader);
      msg.addDailyTransactionVolume(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.sgn.explorer.v1.GetDailyTransactionVolumeResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.sgn.explorer.v1.GetDailyTransactionVolumeResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.sgn.explorer.v1.GetDailyTransactionVolumeResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.sgn.explorer.v1.GetDailyTransactionVolumeResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getErr();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.sgn.explorer.v1.ErrMsg.serializeBinaryToWriter
    );
  }
  f = message.getDailyTransactionVolumeList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.sgn.explorer.v1.DailyTransactionVolume.serializeBinaryToWriter
    );
  }
};


/**
 * optional ErrMsg err = 1;
 * @return {?proto.sgn.explorer.v1.ErrMsg}
 */
proto.sgn.explorer.v1.GetDailyTransactionVolumeResponse.prototype.getErr = function() {
  return /** @type{?proto.sgn.explorer.v1.ErrMsg} */ (
    jspb.Message.getWrapperField(this, proto.sgn.explorer.v1.ErrMsg, 1));
};


/**
 * @param {?proto.sgn.explorer.v1.ErrMsg|undefined} value
 * @return {!proto.sgn.explorer.v1.GetDailyTransactionVolumeResponse} returns this
*/
proto.sgn.explorer.v1.GetDailyTransactionVolumeResponse.prototype.setErr = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.sgn.explorer.v1.GetDailyTransactionVolumeResponse} returns this
 */
proto.sgn.explorer.v1.GetDailyTransactionVolumeResponse.prototype.clearErr = function() {
  return this.setErr(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.sgn.explorer.v1.GetDailyTransactionVolumeResponse.prototype.hasErr = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * repeated DailyTransactionVolume daily_transaction_volume = 2;
 * @return {!Array<!proto.sgn.explorer.v1.DailyTransactionVolume>}
 */
proto.sgn.explorer.v1.GetDailyTransactionVolumeResponse.prototype.getDailyTransactionVolumeList = function() {
  return /** @type{!Array<!proto.sgn.explorer.v1.DailyTransactionVolume>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.sgn.explorer.v1.DailyTransactionVolume, 2));
};


/**
 * @param {!Array<!proto.sgn.explorer.v1.DailyTransactionVolume>} value
 * @return {!proto.sgn.explorer.v1.GetDailyTransactionVolumeResponse} returns this
*/
proto.sgn.explorer.v1.GetDailyTransactionVolumeResponse.prototype.setDailyTransactionVolumeList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.sgn.explorer.v1.DailyTransactionVolume=} opt_value
 * @param {number=} opt_index
 * @return {!proto.sgn.explorer.v1.DailyTransactionVolume}
 */
proto.sgn.explorer.v1.GetDailyTransactionVolumeResponse.prototype.addDailyTransactionVolume = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.sgn.explorer.v1.DailyTransactionVolume, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.sgn.explorer.v1.GetDailyTransactionVolumeResponse} returns this
 */
proto.sgn.explorer.v1.GetDailyTransactionVolumeResponse.prototype.clearDailyTransactionVolumeList = function() {
  return this.setDailyTransactionVolumeList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.sgn.explorer.v1.DailyTransactionVolume.prototype.toObject = function(opt_includeInstance) {
  return proto.sgn.explorer.v1.DailyTransactionVolume.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.sgn.explorer.v1.DailyTransactionVolume} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.sgn.explorer.v1.DailyTransactionVolume.toObject = function(includeInstance, msg) {
  var f, obj = {
time: jspb.Message.getFieldWithDefault(msg, 1, 0),
dailyTransactionVolume: jspb.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.sgn.explorer.v1.DailyTransactionVolume}
 */
proto.sgn.explorer.v1.DailyTransactionVolume.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.sgn.explorer.v1.DailyTransactionVolume;
  return proto.sgn.explorer.v1.DailyTransactionVolume.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.sgn.explorer.v1.DailyTransactionVolume} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.sgn.explorer.v1.DailyTransactionVolume}
 */
proto.sgn.explorer.v1.DailyTransactionVolume.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setTime(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setDailyTransactionVolume(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.sgn.explorer.v1.DailyTransactionVolume.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.sgn.explorer.v1.DailyTransactionVolume.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.sgn.explorer.v1.DailyTransactionVolume} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.sgn.explorer.v1.DailyTransactionVolume.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTime();
  if (f !== 0) {
    writer.writeUint64(
      1,
      f
    );
  }
  f = message.getDailyTransactionVolume();
  if (f !== 0.0) {
    writer.writeDouble(
      2,
      f
    );
  }
};


/**
 * optional uint64 time = 1;
 * @return {number}
 */
proto.sgn.explorer.v1.DailyTransactionVolume.prototype.getTime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.sgn.explorer.v1.DailyTransactionVolume} returns this
 */
proto.sgn.explorer.v1.DailyTransactionVolume.prototype.setTime = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional double daily_transaction_volume = 2;
 * @return {number}
 */
proto.sgn.explorer.v1.DailyTransactionVolume.prototype.getDailyTransactionVolume = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.sgn.explorer.v1.DailyTransactionVolume} returns this
 */
proto.sgn.explorer.v1.DailyTransactionVolume.prototype.setDailyTransactionVolume = function(value) {
  return jspb.Message.setProto3FloatField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.sgn.explorer.v1.ErrMsg.prototype.toObject = function(opt_includeInstance) {
  return proto.sgn.explorer.v1.ErrMsg.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.sgn.explorer.v1.ErrMsg} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.sgn.explorer.v1.ErrMsg.toObject = function(includeInstance, msg) {
  var f, obj = {
code: jspb.Message.getFieldWithDefault(msg, 1, 0),
msg: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.sgn.explorer.v1.ErrMsg}
 */
proto.sgn.explorer.v1.ErrMsg.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.sgn.explorer.v1.ErrMsg;
  return proto.sgn.explorer.v1.ErrMsg.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.sgn.explorer.v1.ErrMsg} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.sgn.explorer.v1.ErrMsg}
 */
proto.sgn.explorer.v1.ErrMsg.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.sgn.explorer.v1.ErrCode} */ (reader.readEnum());
      msg.setCode(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setMsg(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.sgn.explorer.v1.ErrMsg.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.sgn.explorer.v1.ErrMsg.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.sgn.explorer.v1.ErrMsg} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.sgn.explorer.v1.ErrMsg.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCode();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getMsg();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional ErrCode code = 1;
 * @return {!proto.sgn.explorer.v1.ErrCode}
 */
proto.sgn.explorer.v1.ErrMsg.prototype.getCode = function() {
  return /** @type {!proto.sgn.explorer.v1.ErrCode} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.sgn.explorer.v1.ErrCode} value
 * @return {!proto.sgn.explorer.v1.ErrMsg} returns this
 */
proto.sgn.explorer.v1.ErrMsg.prototype.setCode = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional string msg = 2;
 * @return {string}
 */
proto.sgn.explorer.v1.ErrMsg.prototype.getMsg = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.sgn.explorer.v1.ErrMsg} returns this
 */
proto.sgn.explorer.v1.ErrMsg.prototype.setMsg = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * @enum {number}
 */
proto.sgn.explorer.v1.ErrCode = {
  ERROR_CODE_UNDEFINED: 0,
  ERROR_CODE_INVALID_TIME_PARAM: 1
};

goog.object.extend(exports, proto.sgn.explorer.v1);
